import { trackClientEvent } from 'analytics/analytics'

type OfferPagePricingBlockType = 'hotel' | 'hotel_plus_flights'

export function trackOfferPageTopCtaClick(): void {
  trackClientEvent({
    subject: 'offer_page_top_cta',
    action: 'view_package_options_click',
    category: 'offer_page',
    type: 'interaction',
  })
}

export function trackOfferPagePricingBlockViewOptionsClick(type: OfferPagePricingBlockType): void {
  trackClientEvent({
    subject: 'offer_page_pricing_block',
    action: `${type}_view_options_click`,
    category: 'offer_page',
    type: 'interaction',
  })
}

export function trackOfferPageSuggestedPackageViewPackageClick(): void {
  trackClientEvent({
    subject: 'offer_page_suggested_package',
    action: 'view_package_click',
    category: 'offer_page',
    type: 'interaction',
  })
}
